import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useTabs } from '../../context/TabContext';

const Logo = forwardRef(({ disabledLink = false, sx}, ref) => {
  const { clearFiltersAndNavigate } = useTabs();

  const logo = <Box ref={ref} component="img" src="/assets/logo.png" sx={{ maxWidth: 120, width: '100%', ...sx }} />;
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const mobileStyles = {
    height: '20px', 
    width: 'auto', 
    my: 2, 
    ml: 1
  }

  const desktopStyles = {
    height: 'auto',
    cursor: 'pointer',
    maxWidth: 120,
    width: '100%',
    objectFit: 'contain'
  }

  if (disabledLink) {
    return <>{logo}</>;
  }
  return (
    <Box
      ref={ref}
      component="img"
      src={"/assets/logo.png"}
      sx={{ cursor: 'pointer', ...sx, ...(isMobile ? mobileStyles : desktopStyles) }}
      onClick={() => clearFiltersAndNavigate('/dashboard/home')}
    />
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
